(() => {
  const MARK_URL =
    (window.ChikasHeaderLogo && window.ChikasHeaderLogo.markUrl) ||
    '';

  const ensureLogo = () => {
    const link = document.querySelector('a.chikas-header__logo');
    if (!link || !MARK_URL) return;

    let mark = link.querySelector('.chikas-header__mark');
    if (!mark) {
      mark = document.createElement('img');
      mark.className = 'chikas-header__mark';
      mark.alt = '';
      mark.width = 72;
      mark.height = 72;
      mark.decoding = 'async';
      mark.loading = 'eager';
      link.insertBefore(mark, link.firstChild);
    }
    if (mark.tagName === 'IMG' && mark.getAttribute('src') !== MARK_URL) {
      mark.setAttribute('src', MARK_URL);
    }

    link.classList.add('chikas-header__logo--stacked');

    let wordmark = link.querySelector('.chikas-header__wordmark');
    if (!wordmark) {
      wordmark = document.createElement('span');
      wordmark.className = 'chikas-header__wordmark';
      const brand = link.querySelector('.chikas-header__brand');
      const tag = link.querySelector('.chikas-header__tag');
      if (brand) wordmark.appendChild(brand);
      if (tag) wordmark.appendChild(tag);
      if (!brand) {
        const b = document.createElement('span');
        b.className = 'chikas-header__brand';
        b.textContent = 'CHIKAS';
        wordmark.appendChild(b);
      }
      link.appendChild(wordmark);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureLogo);
  } else {
    ensureLogo();
  }
  setTimeout(ensureLogo, 300);
  setTimeout(ensureLogo, 1200);
})();
